import React from 'react';
import omit from 'lodash/omit';
import {loadDocumentDetails} from '../state/document/documentActions';
import {selectDocument} from '../state/document/documentSelectors';
import {connect} from 'react-redux';
import cx from 'classnames';
import * as prettyBytes from 'pretty-bytes';
import './DocumentPreview.css';
import Icon from 'components/Icon';

class DocumentPreview extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {failed: false};
    this.handleError = this.handleError.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadDocumentDetails(this.props.id);
  }

  handleError() {
    this.setState({
      failed: true,
    });
  }

  render() {
    if (!this.props.document) return null;
    const imageUrl =
      `/api/content/v1/doc-previews/${this.props.id}/${
        this.props.document.currentRevision.dataFileRevisionId
      }/PNG?page=1` + (this.props.width ? `&width=${this.props.width}` : '');
    const filename = encodeURIComponent(this.props.document.name || '');
    const downloadUrl = `/api/data/v1/data-files/${this.props.id}/revisions/${
      this.props.document.currentRevision.dataFileRevisionId
    }?fileName=${filename}`;

    if (!this.state.failed) {
      return (
        <a
          href={downloadUrl}
          className="DocumentPreview__Link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            onError={this.handleError}
            src={imageUrl}
            className="DocumentPreview__Image"
            {...omit(this.props, [
              'loadDocumentDetails',
              'document',
              'fallbackContent',
              'id',
            ])}
          />
        </a>
      );
    } else if (this.props.fallbackContent) {
      return this.props.fallbackContent;
    } else {
      return (
        <a href={downloadUrl} target="_blank" rel="noopener noreferrer">
          <div
            className={cx('DocumentPreview__Fallback', this.props.className)}
          >
            <div className="DocumentPreview__FallbackContent">
              <div>
                <Icon icon={Icon.OPTIONS.CARD_FILE} size={Icon.SIZES.THUMB} />
              </div>
              <div>
                {prettyBytes(this.props.document.currentRevision.sizeBytes)}
              </div>
            </div>
          </div>
        </a>
      );
    }
  }
}

export default connect(
  (state, props) => ({
    document: selectDocument(state, props.id),
  }),
  {loadDocumentDetails}
)(DocumentPreview);
